import 'reflect-metadata';
import { Container } from 'inversify';
import { RootLogger } from 'loglevel';
import { History } from 'history';
import Big from 'big.js';
//@ts-ignore
import { module as validatorsLocalizationModule } from '@unitedtraders/validators/localization';
import { iocNames } from './iocNames';
import { I18Service } from './services/I18Service';
import { logger } from './services/Logger';
//@ts-ignore
import { module as localizationModule } from './localization';
import { UtcomApi } from './services/UtcomApi';
import { createApolloClient } from './services/createApolloClient';
import { RootProps } from './types/RootUpdatable';
import { ConversionService } from './services/ConversionService';
import { Handlers } from './types/common';
import { ModalService } from './services/ModalService';

Big.NE = -20;
Big.PE = 40;

export interface Services {}

interface Props
  extends Pick<RootProps, 'getTokens' | 'locale' | 'appConfig' | 'closeModal' | 'goToInvestment'> {
  history: History;
}

export function createIOC({
  getTokens,
  locale,
  appConfig,
  history,
  goToInvestment,
  closeModal,
}: Props) {
  const ioc = new Container({ skipBaseClassChecks: true });

  ioc.bind(iocNames.history).toConstantValue(history);
  ioc.bind(iocNames.getTokens).toConstantValue(getTokens);
  ioc.bind(iocNames.config).toConstantValue(appConfig);

  const handlers: Handlers = {
    goToInvestment: goToInvestment || (() => null),
  };

  ioc.bind(iocNames.handlers).toConstantValue(handlers);

  ioc
    .bind(iocNames.modalService)
    .toDynamicValue(() => new ModalService(closeModal))
    .inSingletonScope();

  // Services
  ioc.bind<RootLogger>(iocNames.logger).toConstantValue(logger);

  ioc.bind<UtcomApi>(iocNames.utcomApi).to(UtcomApi).inSingletonScope();
  ioc.bind<ConversionService>(iocNames.conversionService).to(ConversionService).inSingletonScope();

  const apolloClient = createApolloClient(appConfig.graphqlGateway.url, getTokens);
  ioc.bind(iocNames.apolloClient).toConstantValue(apolloClient);

  ioc
    .bind(iocNames.i18nService)
    .toDynamicValue(({ container }) => {
      const rootLogger = container.get<RootLogger>(iocNames.logger);
      const level = rootLogger.getLogger('i18next').getLevel();
      return new I18Service([localizationModule, validatorsLocalizationModule], level, locale);
    })
    .inSingletonScope();

  // RootUpdatable
  ioc.bind(iocNames.rootUpdatable).toService(iocNames.i18nService);

  return ioc;
}
